module.exports = __webpack_public_path__ + "img/jp.68deed47.svg";